import { observable, action } from 'mobx';

export default class StatementStore {

  defaultParams = {
    selectedStatementStr: 'Current Month',
    selectedWalletStr: 'All Wallets',
    selectedStatement: 0,
    selectedWallet: 'All'
  };

  paramRestrict15Days = {
    selectedStatementStr: 'Last Week',
    selectedWalletStr: 'All Wallets',
    selectedStatement: 2,
    selectedWallet: 'All'
  };

  defaultStatementFilter = {
    statementType: '',
    date: '',
    wallet: '',
  };

  //Mobx store
  @observable selectedOptions = {
    selectedStatement: null,
    selectedWallet: null
  };

  @action
  updateSelectedNewOptions(data) {
    this.selectedOptions = data
  }

  @observable statementFilter = this.defaultStatementFilter;

  @observable dataStatementTable = {
    statements: []
  };

  @observable dataStatementMenu = {
    activeWallets: [],
    defaultParams: this.defaultParams,
    paramRestrict15Days: this.paramRestrict15Days
  };

  @action
  updateStatementFilter(filter) {
    this.statementFilter = filter;
  }

  @action
  resetStatementFilter() {
    this.statementFilter = this.defaultStatementFilter;
  }
  
  @action
  updateStatements(data) {
    this.dataStatementTable.statements = data;
  }

  @action
  updateActiveWallets(data) {
    this.dataStatementMenu.activeWallets = data;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/StatementStore.js